var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FFFAEB",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 20.4999V23.8333M23.0001 27.1666H23.0085M21.8462 16.2431L14.9921 28.0819C14.612 28.7386 14.4219 29.0669 14.45 29.3364C14.4745 29.5714 14.5976 29.785 14.7888 29.924C15.0079 30.0833 15.3873 30.0833 16.1461 30.0833H29.8542C30.613 30.0833 30.9923 30.0833 31.2115 29.924C31.4026 29.785 31.5258 29.5714 31.5503 29.3364C31.5783 29.0669 31.3883 28.7386 31.0081 28.0819L24.154 16.243C23.7752 15.5887 23.5858 15.2616 23.3387 15.1517C23.1232 15.0559 22.8771 15.0559 22.6615 15.1517C22.4144 15.2616 22.225 15.5887 21.8462 16.2431Z",
    stroke: "#F79009",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleIcon);
export default __webpack_public_path__ + "static/media/alert_triangle_icon.d6551587bff120ec7b4098de4a4db524.svg";
export { ForwardRef as ReactComponent };